module.exports = __webpack_public_path__ + "img/HongyunWu.497c51c6.png";